export const FETCH_SPONSORED_BRANDS = 'FETCH_SPONSORED_BRANDS';
export const FETCH_SPONSORED_BRANDS_FULFILLED = 'FETCH_SPONSORED_BRANDS_FULFILLED';

export const getSponsoredBrandsCreator = (segment, promise) => ({
  type: FETCH_SPONSORED_BRANDS,
  payload: promise,
  meta: {
    segment,
  },
});
